import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { usePdfGenerator } from "../hooks/usePdfGenerator";
import ConfigForm from "./ConfigForm";
import { PreviewPanel } from "./PreviewPanel";
import { StatusIndicator } from "./StatusIndicator";

const PdfGenerator = () => {
  const [preview, setPreview] = useState({ visible: false });
  const [defaultLanguage, setDefaultLanguage] = useState("en");
  const showPreview = () => setPreview({ visible: true });

  const {
    config,
    updateConfig,
    updatePreset,
    resetConfig,
    status,
    generatePdf,
    resetStatus,
    loadRules,
  } = usePdfGenerator();

  const { t, i18n } = useTranslation();

  // Check if a 'language' parameter exists in the URL and set the default language accordingly
  useEffect(() => {
    // Priorité 1: Langue passée par PHP via window.REACT_LANG
    if (window.REACT_LANG) {
      // console.log("🌐 Langue définie par PHP:", window.REACT_LANG);
      setDefaultLanguage(window.REACT_LANG);
      i18n.changeLanguage(window.REACT_LANG);
      return;
    }

    // Priorité 2: Paramètre 'language' dans l'URL
    const params = new URLSearchParams(window.location.search);
    const langParam = params.get("language");
    if (langParam) {
      // console.log("🌐 Langue depuis URL:", langParam);
      setDefaultLanguage(langParam);
      i18n.changeLanguage(langParam);
      return;
    }

    // Priorité 3: Langue du navigateur
    const browserLanguage = navigator.language.split("-")[0];
    console.log("🌐 Langue du navigateur:", browserLanguage);
    setDefaultLanguage(browserLanguage);
    i18n.changeLanguage(browserLanguage);

    // No dependencies: run only on mount
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <div className="p-8 mx-auto max-w-6xl">
        <header className="mb-3 text-center">
          <div className="inline-block px-12 py-5 rounded-2xl shadow-xl bg-primary-gradient">
            <h1 className="text-3xl font-bold text-accent-700">
              {t("pdfGenerator.title")}
            </h1>
          </div>

          {/* Sélecteur de langue */}
          {/* <div className="flex justify-center mt-4">
            <LanguageSelector />
          </div> */}
        </header>

        <main className="space-y-8">
          <ConfigForm
            defaultLanguage={defaultLanguage}
            config={config}
            onConfigChange={updateConfig}
            updatePreset={updatePreset}
            showPreview={showPreview}
            onGenerate={generatePdf}
            onReset={resetConfig}
            disabled={status.loading}
          />

          <PreviewPanel
            config={config}
            loadRules={loadRules}
            preview={preview}
            onClose={() => setPreview({ visible: false })}
          />

          <StatusIndicator
            status={status}
            outputFormat={config.outputFormat}
            onClose={resetStatus}
          />
        </main>
      </div>
    </div>
  );
};

export default PdfGenerator;
